<script>
import BaseHeader from "@/components/BaseHeader.vue";
import BaseIframe from "@/components/BaseIframe.vue";

export default {
  name: "DonateView",
  components: {
    BaseIframe,
    BaseHeader
  },
}
</script>

<template>
  <base-header/>
  <Base-iframe :src="'/donate?_f=true'"/>
</template>